@use "../../../../globals/settings";
@use "../../../../globals/bcp";
@use "../../../../globals/bcp-2022/objects/lists";
@use "../../../../globals/bcp-2022/objects/links";

$self: ".o-breadcrumbs";

:host {
  // ------------------- FIX CUSTOM TAGS ------------------------------------------------------------------------------
  display: block;
}

// ------------------- BCP ------------------------------------------------------------------------------------------
.o-breadcrumbs {
  @include lists.list("horizontal", 0.5rem);

  &__item {
    &--current {
      #{$self}__link {
        @include links.primary-icon {
          display: none;
        }
      }
    }
  }

  &__link {
    @include links.with-icon;
    @include links.primary;
    font-size: bcp.size(bcp.getFontSize("s"), settings.$rel-unit);
    color: settings.$text-color;
    text-decoration: none;

    &:hover {
      color: bcp.colorVar("link-hover");
      text-decoration: underline;
    }
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
